<script setup>
import { useGlobalStore } from "@stores/global";
import { ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import Button from "@components/global/button.vue";

const breakpoints = ref({
  0: {
    slidesPerView: 2,
  },
  500: {
    slidesPerView: 3,
  },
});

const global = useGlobalStore();
</script>

<template>
  <div class="overflow-hidden w-full h-full relative">
    <img
      src="https://hennep.s3.amazonaws.com/above/images/home/hero/bg.jpg"
      alt=""
      class="absolute md:opacity-100 opacity-70 inset-0  top-0 w-full h-full object-cover"
    />
    <section
      class="container w-full md:h-screen h-full flex flex-col items-center text-purple-300 uppercase font-body tracking-tight text-body-sm font-medium"
    >
      <img
        src="https://hennep.s3.amazonaws.com/above/images/home/hero/logo.svg"
        alt=""
        class="w-full md:block hidden h-full object-contain ml-[1.5%] min-h-[800px]"
      />

      <div class="mt-[60px] md:hidden gap-6 w-full">
        <img
          src="https://hennep.s3.amazonaws.com/above/images/home/hero/label.svg"
          alt=""
        />
        <img
          src="https://hennep.s3.amazonaws.com/above/images/logo-footer.svg"
          class="w-full h-full mt-6"
          alt=""
        />
      </div>

      <div
        class="max-w-80 md:absolute block w-half md:mt-0 mt-20 self-end md:w-full 2xl:left-[80%] right-0 top-[20%] text-purple-300"
      >
        Excepteur do minim eu ad eu anim quis qui elit non ullamco.<br /><br />Consectetur
        proident anim id pariatur minim laboris aute irure dolor enim sunt
        nostrud.
      </div>

      <div
        class="md:absolute mt-20 md:mt-0 flex left-[80%] bottom-[20%] gap-3 items-center w-[42]"
      >
        <div class="w-1 h-1 -rotate-45 bg-purple-300"></div>
        <span> keep scrolling </span>
      </div>

      <div
        class="overflow-hidden md:block hidden sm:self-start h-[70px] w-[300px]"
      >
        <Swiper :breakpoints="breakpoints" class="h-full">
          <SwiperSlide
            v-for="social in global.socials"
            :key="social.avatar_url"
            class="flex items-center justify-center"
          >
            <Button
              class="btn-outline small"
              :key="social.avatar_url"
              :href="social.link"
              :title="`${social.platform?.name} - ${social.username}`"
            >
              <i
                :class="social.platform?.icon"
                class="flex items-center justify-center w-4 h-4"
              />
            </Button>
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  </div>
</template>
